// eslint-disable-next-line import/prefer-default-export
export const percentage = {
  decimalScale: 3,
  min: 0,
  suffix: '%',
};

export const year = {
  format: '####',
  mask: 'Y',
};
